import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
// import { $ } from 'protractor';
import { RouterLink } from '@angular/router';
// import * as $ from 'jquery';
declare var $: any;
@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  data: any ={};
  public showAddFamily: boolean = false;
  public iconVisibility: boolean = false;
  familyMemberName: any;
  familyMemberRelation: any;
  familyMemberDob: any;
  error: any;
  otpMobileEmail: any;
  mobileNumber: any;
  name: any;
  email: any;
  _id: any;
  partnerId: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    var hostname = window.location.hostname;
    if( hostname == "staging.securenow.app" || hostname == "localhost"){
      this.partnerId = "997";
    }
    else if(hostname == "securenow.app"){
      this.partnerId = "997";
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) ) {
      event.preventDefault();
    }
  }

  // showAddFamilyFunc(){
  //    this.showAddFamily = true;
  // }

  backToReg(){
    this.showAddFamily = false;
 }

  onSubmit() {
    
    this.data.family = [];
    if(this.showAddFamily){
     this.data.family.push({ 
      'relationship': this.familyMemberRelation, 
      'name': this.familyMemberName,
      'dob': (new Date(this.familyMemberDob).getTime())
    });
  }

    //alert(JSON.stringify(this.data));
    this.data = {
      "name": this.capitalizeFirstLetter(this.data.name),
      "mobile": this.data.mobile.trim().toLowerCase(),
      "email": this.data.email.trim().toLowerCase(),
      "dob": "",
      "company":"",
      "family": "[]"
      // "email": this.data.email,
      // "dob": (new Date(this.data.dob).getTime()).toString(),
      // "company":this.data.company,
      // "family": JSON.stringify(this.data.family)
    }
    this.serviceURLService.registration(this.data).pipe(takeUntil(this.onDestroy$)).subscribe(successData => {
      console.log("Registered Successfully");
      this.mobileNumber = this.data.mobile?this.data.mobile:'';
      this.name = this.data.name
      this.email = this.data.email
      //this._id = successData['response']['_id']
      localStorage.setItem("mobileNumber", this.mobileNumber)
      localStorage.setItem("name", this.name)
      localStorage.setItem("email", this.email)
      //localStorage.setItem("userID", this._id)
      document.getElementById("otpPartition").style.display = "block";
      document.getElementById("sendOTPButton").style.display = "none";
      //this.router.navigate(['otp']);
    }, errorData => {
      
      console.log("not registered");
      
      if(errorData.error.status === 400){
        this.error = errorData.error.message;
        setTimeout(() => {
          this.error = "";
        }, 3000);
      }
    })
  }

  verifyOTPNumber() {
    this.otpMobileEmail = localStorage.getItem('mobileNumber');
    if(this.otpMobileEmail==''){
      this.otpMobileEmail = localStorage.getItem('email')
    }
    this.serviceURLService.verifyOTP(this.otpMobileEmail, this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      localStorage.setItem('authToken', JSON.stringify(successData.response.authToken));
      localStorage.setItem('userID', successData['response']['_id']);
      this.router.navigate(['home']);
      // if(localStorage.getItem('mobileNumber')!=''){
      //   this.createProspect();
      // }

      if(successData.response.isPolicyLaunch){
        var LaunchFlag = successData.response.isPolicyLaunch
        if(LaunchFlag.length > 0){
          if(LaunchFlag[0].isTrue === true){
            localStorage.setItem("checkLaunchFlag", "true");
          }
        }
      }
      if (successData.response.firsttimeLogin) {
        let userData={
          "name":successData.response.name,
          "email":successData.response.email,
          "mobile":successData.response.mobile
        }
        this.serviceURLService.sendFirstLoginMail(userData).pipe(takeUntil(this.onDestroy$)).subscribe((sucess:any)=>{
          console.log("Welcome login mail sent successfully");
        }, err=>{
          console.log("Oops..!! error in send welcome login mail");
        })
      }
    }, errorData => {
      console.log("Oops..!! there is some error in OTP varification");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  createProspect() {

    this.data = {
      "mobile": this.data.mobile,
      "prospectId" : "",
      "rmId" : "",
      "product" : "",
      "email" : this.data.email,
      "name" : this.data.name,
      "company" : "",
      "location" : "",
      "designation" : "",
      "comment" : "",
      "partnerId" : this.partnerId,
      "channel" : "Notify-App",
      "leadSource": "Notify-App",
      "googleClickID" : "",
      "couponCode" : ""
    }

    this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.router.navigate(['home']);
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  backClicked() {
    this._location.back();
  }

  termsModalPopup() {
    $("#termsModal").modal("show");
  }

  capitalizeFirstLetter(string) {
    try {
      if (!string || typeof string !== 'string') return '';

      string = string.replace(/\.$/, '');
      string = string.replace(/\s+/g, ' ').trim();

      return string.split(' ').map(word => {
        if (word.length > 0) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        } else {
          return '';
        }
      }).join(' ');
    } catch (error) {
      console.log('Method:capitalizeFirstLetter', 'Error:', error.message);
      return ''; // return default value on failure
    }
  };

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
